<template>
   <svg :width="props.width" :height="props.height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M17.5 18.332H2.5C2.15833 18.332 1.875 18.0487 1.875 17.707C1.875 17.3654 2.15833 17.082 2.5 17.082H17.5C17.8417 17.082 18.125 17.3654 18.125 17.707C18.125 18.0487 17.8417 18.332 17.5 18.332Z"
            :fill="props.color" />
          <path
            d="M15.8495 2.90005C14.2328 1.28338 12.6495 1.24172 10.9912 2.90005L9.98283 3.90838C9.89949 3.99172 9.86616 4.12505 9.89949 4.24172C10.5328 6.45005 12.2995 8.21672 14.5078 8.85005C14.5412 8.85838 14.5745 8.86672 14.6078 8.86672C14.6995 8.86672 14.7828 8.83338 14.8495 8.76672L15.8495 7.75838C16.6745 6.94172 17.0745 6.15005 17.0745 5.35005C17.0828 4.52505 16.6828 3.72505 15.8495 2.90005Z"
            :fill="props.color" />
          <path
            d="M13.0089 9.60963C12.7673 9.49297 12.5339 9.3763 12.3089 9.24297C12.1256 9.13464 11.9506 9.01797 11.7756 8.89297C11.6339 8.8013 11.4673 8.66797 11.3089 8.53463C11.2923 8.5263 11.2339 8.4763 11.1673 8.40964C10.8923 8.1763 10.5839 7.8763 10.3089 7.54297C10.2839 7.5263 10.2423 7.46797 10.1839 7.39297C10.1006 7.29297 9.95892 7.1263 9.83392 6.93463C9.73392 6.80963 9.61726 6.6263 9.50892 6.44297C9.37559 6.21797 9.25892 5.99297 9.14226 5.75964V5.75964C8.98929 5.43185 8.55908 5.33448 8.30331 5.59025L3.61726 10.2763C3.50892 10.3846 3.40892 10.593 3.38392 10.7346L2.93392 13.9263C2.85059 14.493 3.00892 15.0263 3.35892 15.3846C3.65892 15.6763 4.07559 15.8346 4.52559 15.8346C4.62559 15.8346 4.72559 15.8263 4.82559 15.8096L8.02559 15.3596C8.17559 15.3346 8.38392 15.2346 8.48392 15.1263L13.1777 10.4325C13.4284 10.1819 13.3342 9.75058 13.0089 9.60963V9.60963Z"
            :fill="props.color" />
        </svg>
</template>
<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    color: {
        type: String,
        default: 'black',
    },
    width: {
        type: Number,
        default: 20,
    },
    height: {
        type: Number,
        default: 20,
    },
});
</script>